<template>
  <div class="display">
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center targetFirst_loading">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    
    <v-layout row wrap class="layoutTraficVisiteurs bigChat">
      <v-flex xs12 :class="{sm3: messageAttenteSelected}" class="traficListVisiteurs fill-height">
        <v-card class="cardTraficVisiteurs">
          <v-toolbar class="toolbar--dense white" flat >
            <v-toolbar-title class="primary--text">
              {{$tc('messageAttente', user.listeMessages.length, {count: user.listeMessages.length})}}
              <!--{{ $tc('messages en attentes', listeMessages.length, { count: listeMessages.length })}}-->
              <v-btn
                v-if="status != 'online'"
                :loading="loadingMessages"
                :disabled="loadingMessages"
                color="primary"
                class="white--text"
                @click="getMessagesAttentes()"
              >
                {{$tc('Reload')}}
                <v-icon right dark>cached</v-icon>
              </v-btn>
            </v-toolbar-title>
          </v-toolbar>

          <div
            class="wz_contentListesVisiteurs" 
            v-bar
          >
 
            <v-list two-line dense class="listeTraficVisiteurs">
              <v-subheader>General</v-subheader>
                <template class="wz_wrapChips" v-for="(visitor, i) in user.listeMessages">
                  <v-flex xs12 sm12
                    :key="i"
                    class="visiteurFiltrer"
                  >
                      <v-list-tile
                        :class="{ 'light-blue lighten-4': messageAttenteSelected == visitor.visiteurID,  }"
                        ripple
                        :key="visitor.status"
                        @click="openMessageVisiteur(visitor)"
                      >
                      
                        <v-list-tile-avatar>
                          <wz-avatar
                            v-if="!dejaEnChat && visitor.network == 'moon' || !dejaEnChat && !visitor.network"
                            :username="'#' + visitor.visiteurID"
                            size="38px"
                            class="pl-1"
                          ></wz-avatar>
                          <wz-avatar
                            v-else-if="!dejaEnChat && visitor.network == 'facebook'"
                            :src="visitor.profile_pic"
                            :username="visitor.visiteurName"
                            size="38px"
                            class="pl-1"
                          ></wz-avatar>
                          <wz-avatar
                            v-else-if="!dejaEnChat && !istypingVisiteur && visitor.message && visitor.visiteurID != messageAttenteSelected"
                            :username="'#' + visitor.visiteurID"
                            size="38px"
                            lastMessage
                          ></wz-avatar>
                          <wz-avatar
                            v-else-if="!dejaEnChat && istypingVisiteur"
                            :isTyping="istypingVisiteur"
                            :username="'#' + visitor.visiteurID"
                            size="38px"
                            chip
                          ></wz-avatar>


<!--
                          <wz-avatar-double
                            v-if="dejaEnChat && !istypingVisiteur && !visitor.message && visitor.visiteurID != messageAttenteSelected"
                            :avatars="[{id: visitor.visiteurName, isTyping: false, chip: true, lastMessage: visitor.message}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
                          ></wz-avatar-double>
                          <wz-avatar-double
                            v-else-if="dejaEnChat && !istypingVisiteur && !visitor.message && visitor.visiteurID == messageAttenteSelected"
                            :avatars="[{id: visitor.visiteurName, isTyping: false, chip: true, lastMessage: visitor.message}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
                          ></wz-avatar-double>
                          <wz-avatar-double
                            v-else-if="dejaEnChat && !istypingVisiteur && visitor.message && visitor.visiteurID != messageAttenteSelected"
                            :avatars="[{id: visitor.visiteurName, isTyping: false, chip: true, lastMessage: visitor.message}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
                          ></wz-avatar-double>
                          <wz-avatar-double
                            v-else-if="dejaEnChat && istypingVisiteur"
                            :avatars="[{id: visitor.visiteurName, isTyping: true, chip: true}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
                          ></wz-avatar-double>
                          <wz-avatar-double
                            v-else-if="visitor.network"
                            :avatars="[{id: dejaEnChat.sessionID, username: visitor.visiteurName, src: visitor.profile_pic}, {id: dejaEnChat.agentID, username: dejaEnChat.agentName}]"
                          ></wz-avatar-double>
-->
                        </v-list-tile-avatar>
                        
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <div v-if="visitor.network == 'moon' || !visitor.network" class="wz_nameVisiteur">
                              {{visitor.visiteurID}} <span>({{dateMessageFromNow(visitor.timestamp)}})</span>
                            </div>
                            <div v-else-if="visitor.network == 'facebook'" class="wz_nameVisiteur">
                              {{visitor.visiteurName}} <span>({{dateMessageFromNow(visitor.timestamp)}})</span>
                            </div>
                          </v-list-tile-title>
                          <v-list-tile-sub-title v-if="visitor.message.length">
                              <div
                                slot="activator"
                                v-if="visitor.message.length"
                                class="wz_alertFiltre "
                              >
                                <v-icon v-if="visitor.network == 'moon' || !visitor.network" small class="secondary--text text--lighten-1">chat_bubble</v-icon>
                                <v-icon v-else-if="visitor.network == 'facebook'" small color="blue accent-4--text" class=" ">mdi-facebook-messenger</v-icon> 
                              </div>
                            {{visitor.message[0]}}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-btn flat slot="activator" icon color="accent"
                            @mouseover.native="overMenu = true"
                            @mouseleave.native="overMenu = false"
                            @click="suppMessage(visitor.messageId)"
                          >
                            <v-icon large color="grey lighten-1">close</v-icon>
                          </v-btn>
                        </v-list-tile-action>

                      </v-list-tile>
                     <v-divider inset></v-divider> 
                  </v-flex>
                </template>

            </v-list>
          </div>
        </v-card>
      </v-flex>
      <v-flex v-if="messageAttenteSelected" xs12 sm9 class="traficInfosVisiteur fill-height">
        <div v-if="loadingHistoChat" class="wz_loadingChat text-xs-center">
          <v-progress-circular :size="70" :width="1" indeterminate class="primary--text"></v-progress-circular>
        </div>
        <wz-view-chat
          v-else
          :datasViewPupitre="dataVisiteurComputed"
          :placesPupitre="1"
          @click.native="focusView({'view': 1, 'visiteurID': messageAttenteSelected})"
          @activeCobrowsing="openCobrowsing(0)"
          @stopCobrowsing="closeCobrowsing(0)"
          @MAJHistoChat="MAJHistoChat"
        ></wz-view-chat>
      </v-flex>
    </v-layout>

    <!-- dialogBox de confirmation de suppression-->
    <v-dialog v-model="dialogSupMessage" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('supMessageAttenteTitre') | cap }}</v-card-title>
        <v-card-text>
          {{ $t('supMessageAttenteContent') | cap }}
        </v-card-text>
        <!-- $t('contentDialogSessionClose') -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="dialogSupMessage=false">{{$t('no')}}</v-btn>
          <v-btn
            class="white--text darken-1"
            :loading="loadingSupp"
            :disabled="loadingSupp"
            color="accent"
            @click="confirmSuppMessage()"
          >
          {{$t('yes')}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<style>
.targetFirst_loading {
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  position: fixed;
}
.layoutTraficVisiteurs.smallChat .traficInfosVisiteur {
    -ms-flex-preferred-size: 75% !important;
    flex-basis: 75% !important;
    max-width: 75% !important;
}

.visiteurAttente .v-avatar {
    float: left;
}
.layoutTraficVisiteurs {
  height: calc(100vh - 104px) !important;
}

.cardTraficVisiteurs {
  height:100% !important;
}
.wz_contentListesVisiteurs {
  height: calc(100vh - 176px);
  overflow: auto;
  position: relative;
}
.wz_loadingChat {
  top: calc(50% - 35px);
  position: relative;
}
</style>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapMutations } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js'
import monitor from '../../mixins/monitor'
import moment from 'moment'
export default {
  mixins: [monitor],

  data () {
    return {
      loadingGet: false,
      dialogSupMessage: false,
      loadingSupp: false,
      loadingMessages: false,
      chatStatus: false,
      listeComputedMessages: [],
      loadingHistoChat: false,
      visiteurData: {},
      dejaEnChat: 0,
      istypingVisiteur: 0,
      messageIdSelected: 0
    }
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', [
      'SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE'
    ]),
    ...mapMutations('_User', [
      'SET_MESSAGE_ATTENTE',
      'SET_AVATAR_MESSAGE_ATTENTE'
    ]),
    // ----------------------------------------------------------------------------
    // supprime un message
    // ----------------------------------------------------------------------------
    suppMessage (Id) {
      this.messageIdSelected = Id
      // affiche la fenetre de confirmation
      this.dialogSupMessage = true
    },

    // ----------------------------------------------------------------------------
    // Il faut mettre à jour l'historique de chat pour les message en attentes uniquement
    // ----------------------------------------------------------------------------
    MAJHistoChat (data) {
      // console.log('MAJHistoChat', e)
      this.MonitorMajHistoChat(data)
    },

    // ------------------------------------------------------------------------------
    // Chargement des messages en attentes
    // ------------------------------------------------------------------------------
    getMessagesAttentes () {
      // console.log('get messages', this.user.id)
      // this.loadingGet = true
      this.loadingMessages = true
      this.axios
      .get(
        'get/chats_abscence.php?agentId=' +
          this.user.id
      )
      .then(response => {
        // console.log('response', response)
        this.SET_MESSAGE_ATTENTE(response.data)
        // parse le tableau pour trouve le visiteur qui vient d'un reseau social
        _.forEach(
          response.data,
          (allVisiteurs, key) => {
            if (allVisiteurs.network === 'facebook') {
              // console.log('visiteur facebook : ', allVisiteurs.visiteurName)
              let dataVisiteur = {'visiteurData': allVisiteurs, 'key': key}
              this.getAvatarVisiteur(dataVisiteur)
            }
          }
        )
        // console.log('this.listeMessages', this.listeMessages)
        // this.loadingGet = false
        // console.log('length', this.listeMessages.length)
        this.loadingMessages = false
      })
      .catch(_ => {
        // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
      })
      .then(_ => {
      })
    },

    // ------------------------------------------------------------------------------
    // Ajout de l'avatar si message en attente reseaux sociaux
    // ------------------------------------------------------------------------------
    getAvatarVisiteur (data) {
      // console.log('data', data)
      this.axios
      .get(
        'get/chats_abscence_avatar.php?visitorId=' +
          data.visiteurData.visiteurID
      )
      .then(response => {
        // console.log('response', response.data)
        if (response.data) {
          // return response.data
          data.visiteurData.profile_pic = response.data
          // let messagesList = _.cloneDeep(this.$store.state._User.user.listeMessages)
          // messagesList.splice(data.key, 1, data.visiteurData) // change l'etat du over sur le drop
          this.SET_AVATAR_MESSAGE_ATTENTE(data)
          this.loadingMessages = false
          // console.log('this.listeMessages', this.user.listeMessages)
        }
      })
      .catch(_ => {
        // window.alert('totejfojiz ezuihf uihezhf uihs of uge')
      })
      .then(_ => {
      })
    },

    // ----------------------------------------------------------------------------
    // confirmation de la suppression du message
    // ----------------------------------------------------------------------------
    confirmSuppMessage () {
      // console.log('confirmSuppMessage', this.messageIdSelected)
      let suppId = this.messageIdSelected
      let dataToPost = new window.FormData()
      dataToPost.append('messageId', suppId)
      // indique en base que le message est lu
      this.axios
      .post('post/messageAttenteLu.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      // les changements été pris en compte
      // il faut retirer le message de la liste
      .then(response => {
        // console.log('post', response)
        // clone le tableau avant de travailler dessus
        let messagesList = _.cloneDeep(this.user.listeMessages)
        // recupère l'index du message supprimé
        let index = _.findIndex(messagesList, function (o) { return o.messageId === suppId })
        if (index !== -1) {
          messagesList.splice(index, 1)
          // remplace le tableau par celui cloné et modifié
          this.user.listeMessages = messagesList
        }
      })
      .catch(_ => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('modifFailure'),
          context: 'error'
        })
      })
      .then(_ => {
        // stop le loading du bouton
        this.loadingSupp = false
        // ferme la fenetre dialog
        this.dialogSupMessage = false
        this.messageIdSelected = 0
      })
    },

    // ----------------------------------------------------------------------------
    // Si ce visiteur est deja en chat
    // Check avec quel agent ce visiteur est en chat
    // si c'est moi j'ouvre le chat si c'est un autre agent j'ouvre une dialogBox
    // ----------------------------------------------------------------------------
    openMessageVisiteur (data) {
      // console.log('openMessageVisiteur', this.visiteurData)
      // console.log('entId', this.user.entId)
      if (this.overMenu) return
      if (this.messageAttenteSelected === data.visiteurID) {
        // return // pour eviter d'ouvrir un chat deja ouvert
      } else {
        this.loadingHistoChat = true
        // --------------- DEMANDE HISTORIQUE DE CHAT
        _watcheebox
          .firstLoadHistoChat({
            chatSession: data.visiteurID,
            entrepriseId: this.user.entId
          })
          .then(histoChat => {
            // console.log('histoChat', histoChat)
            let visClone = _.cloneDeep(data)
            visClone.histoChat = histoChat
            // enregistre les donnée du visiteur dans le store
            // console.log('set visiteur openchat', visClone)
            this.showChat(visClone)
            this.visiteurData = visClone // mise à jour des data visiteur selectionné
            // mise à jour du store pour les donnée visiteur offline
            let visOfflineClone = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened)
            visOfflineClone.histoChat = histoChat
            this.SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE(visOfflineClone)
          })
          .catch(e => {
            console.error(e)
          })
        // -------------------------------------------
      }
    },

    // ----------------------------------------------------------------------------
    // chargement avant affichage du chat et des infos
    // ----------------------------------------------------------------------------
    loadingChat (visiteurInfos) {
      // this.visSelected = visiteurInfos.visiteurID // indique quel visiteur est selectionné
      this.loadingHistoChat = true
    },

    // ----------------------------------------------------------------------------
    // affiche le chat
    // ----------------------------------------------------------------------------
    showChat (visiteurInfos) {
      // console.log('showChat', visiteurInfos)
      this.loadingHistoChat = false
      this.chatStatus = true // iframe visible
      // Connection à la room visiteur
      _watcheebox.clientConnectRoom({'roomName': 'chat_' + visiteurInfos.visiteurID})
      // Enregistre dans le store l'id du visiteur
      this.$store.commit('_StoreWatcheeBox/VISITEUR_ADD_CHAT', {sessionID: visiteurInfos.visiteurID})
      // this.startCheckInfos() // start le monitor
      // indique que la fiche visiteur est ouverte
      this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', visiteurInfos)
    },

    dateMessageFromNow (date) {
      // var dateString = moment.unix(date)
      // console.log('date', dateString)
      // return dateString
      return moment.unix(date).fromNow()
    }
  },

  created () {
    if (this.hideTabVisitors) {
      this.$router.push({ path: '/trafic/attente' })
    }
    // clear les data du visiteur deja ouvert pour ne pas ouvrire par defaut une fenetre chat avec des erreurs js
    this.$store.commit('_StoreWatcheeBox/CLEAR_MESSAGE_ATTENTE')
  },

  mounted () {
  },

  beforeDestroy () {
  },

  watch: {
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapState('_User', ['hideTabVisitors']),
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'newMessage',
      'mySocketID',
      'listeChatAgent',
      'messageAttenteSelected',
      'allDataVisiteurOpened',
      'status'
    ]),

    dataVisiteurComputed () {
      // console.log('dataVisiteurComputed')
      let visiteurDataSelected
      let index
      // console.log('this.messageAttenteSelected', this.messageAttenteSelected)
      // si le visiteur est en ligne
      if (!this.filterFront) {
        // console.log('visiteur online')
        index = _.findIndex(this.concatAllVisiteurs, {'visiteurID': this.messageAttenteSelected})
        // console.log('index 1 : ', index)
        if (index !== -1) {
          visiteurDataSelected = this.concatAllVisiteurs[index]
        }
        // visiteurDataSelected = _.find(this.concatAllVisiteurs, {'visiteurID': this.messageAttenteSelected})
      } else {
        // console.log('visiteur offline')
        // visiteurDataSelected = _.find(this.listeAllVisiteurs, {'visiteurID': this.messageAttenteSelected})
        index = _.findIndex(this.listeAllVisiteurs, {'visiteurID': this.messageAttenteSelected})
        // console.log('index 2 : ', index)
        if (index !== -1) {
          visiteurDataSelected = this.listeAllVisiteurs[index]
          visiteurDataSelected.histoChat = this.allDataVisiteurOpened.histoChat
        }
      }
      // console.log('index', index)
      if (index === -1) {
        // il faut recuperer le bon histoChat dans le store 'allDataVisiteurOpened'
        // c'est celui qui est mise à jour pour les messages visiteur offline en attente
        let MAJHistoCHat = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat)
        this.visiteurData.histoChat = MAJHistoCHat
        // c'est le visiteurDataSelected avec l'histoChat à jour pour les messages en attentes
        visiteurDataSelected = this.visiteurData
      }
      // console.log('visiteurDataSelected', visiteurDataSelected)
      return {'cobrowsing': false, 'online': true, 'viewStatus': true, 'visiteurDatas': visiteurDataSelected, 'visiteurID': this.messageAttenteSelected}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/trafic/Attente.vue